import type { Components } from '@mui/material/styles';

export default function MuiButtonBase(): Components['MuiButtonBase'] {
  return {
    defaultProps: {
      color: 'neutral',
    },
  };
}
